<script lang="ts">
    import {createCostCenter as create, getCostCenters, getUnits, updateCostCenter as update} from "$lib/calls/unit";
    import {onMount} from "svelte";
    import {Button, Heading, Input, Label, Modal, Select} from "flowbite-svelte";
    import {allUnits} from "$lib/stores/unit";
    import {PlusOutline} from "flowbite-svelte-icons";

    let costCenters = [];
    let newCostCenter = {
        name: '',
        key: '',
        unitId: 1
    }
    let sortedCostCenters = [];

    let open = false

    const updateCostCenter = async (costCenter) => {
        costCenters = [...costCenters.filter(x => x.id !== costCenter.id), await update(costCenter)]
    }
    const createCostCenter = async () => {
        costCenters = [...costCenters, await create(newCostCenter)]
    }

    onMount(async () => {

        if ($allUnits.length === 0) {
            $allUnits = await getUnits()
        }
        getCostCenters().then(x => {
            costCenters = x
            sortedCostCenters = costCenters.sort((a, b) => a.name.localeCompare(b.name))
        })

    })
</script>
<div class="flex gap-5">
    <section class="flex-1">
        <Heading class="text-neutral-500 mb-3 flex justify-between" tag="h3">
            <span>Kostenstellen</span>
            <Button on:click={() => open = true}><PlusOutline/> Neue Kostenstelle</Button>
        </Heading>
        {#each sortedCostCenters as costCenter}
            <form class="grid grid-cols-6 gap-3 mb-3" on:submit|preventDefault={() => updateCostCenter(costCenter)}>
                <Label class="space-y-2 col-span-2">
                    <span>Name</span>
                    <Input type="text" bind:value={costCenter.name}/>
                </Label>
                <Label class="space-y-2">
                    <span>Kostenstellenschlüssel</span>
                    <Input type="text" bind:value={costCenter.key}/>
                </Label>
                <Label class="space-y-2 col-span-2">
                    <span>Unit</span>
                    <Select bind:value={costCenter.unitId} items={$allUnits.map(x => ({value: x.id, name: x.name}))}/>
                </Label>
                <div class="grid place-items-end">
                    <Button type="submit">Update</Button>
                </div>
            </form>
        {/each}
    </section>

</div>
<Modal bind:open class="w-full">
    <Heading class="text-neutral-500" tag="h3">Neue Kostenstelle</Heading>
    <form class="grid gap-5" on:submit|preventDefault={createCostCenter}>
        <Label class="space-y-2">
            <span>Name</span>
            <Input type="text" bind:value={newCostCenter.name}/>
        </Label>
        <Label class="space-y-2">
            <span>Kostenstellenschlüssel</span>
            <Input type="text" bind:value={newCostCenter.key}/>
        </Label>
        <Label class="space-y-2">
            <span>Unit</span>
            <Select bind:value={newCostCenter.unitId} items={$allUnits.map(x => ({value: x.id, name: x.name}))}/>

        </Label>
        <div>
            <Button type="submit">Anlegen</Button>
        </div>
    </form>
</Modal>
